import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=4028fe3d&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4028fe3d')) {
      api.createRecord('4028fe3d', component.options)
    } else {
      api.reload('4028fe3d', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=4028fe3d&", function () {
      api.rerender('4028fe3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/reports/invoice-recurring/IndexPage.vue"
export default component.exports